import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { goToPage, setIsSubmit, setPopUp, reportDWH, reportAnalytics, setSelectedPackage } from '../PremiumPackagesCatalogSlice';
import { premiumPackageActionAsync } from '../premiumPackagesCatalogAsyncThunk';
import { setCurrentProcess, setSelectedTvSubscriber, setRegistrationParams } from '../../StreamingRegistrationRedirectionBlock/StreamingRegistrationSlice';
import { StreamingRegistrationProcessTypes, DISNEY_REGISTRATION_PARAMS, HBO_REGISTRATION_PARAMS } from '../../StreamingRegistrationRedirectionBlock/utils/constants';
import PackageHeader from '../Partials/packageHeader/packageHeader';
import PackageExistDetails from '../Partials/packageExistDetails/packageExistDetails';
import Config from 'app/Config';

const PackageExistPage = (props) => {

    let purpleTitle = "";
    let boldTitle1 = "";
    let boldTitle2 = "";
    let extraBoldTitle = props.selectedPackage.cmsData?.selfCare?.title ? props.selectedPackage.cmsData.selfCare.title : props.selectedPackage.localizedName;
    console.log(props.selectedPackage.id);
    console.log(props);
    let formid = 'premiumPackagesCatalogForm';

    useExtendedEffect((runSideEffects) => {
        props.reportDWH({ actionType: 'Existing Package Page', status: 'Ongoing', messageText: 'Package Page Displayed' });
        if (props.selectedPackage.duration == 0) {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_4',
                eventLabel: extraBoldTitle,
            });
        }
        else {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_5',
                eventLabel: extraBoldTitle,
            });
        }
        if (runSideEffects()) {

        }
    }, []);

    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            {purpleTitle && <h1 className='purple-title'>{purpleTitle}</h1>}
            {boldTitle1 && <h2 className='bold-title1'> {boldTitle1} </h2>}
            {boldTitle2 && <h2 className='bold-title2'> {boldTitle2} </h2>}
            {extraBoldTitle && <h3 className='extra-bold-title'> {extraBoldTitle} </h3>}
        </div>

    );

    function onHboRegistrationClick() {
        props.setRegistrationParams(HBO_REGISTRATION_PARAMS);
        props.setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_EXIST);
        props.setSelectedTvSubscriber(props.selectedSubscriber?.subscriberNo);
        props.context.navigateTo(Config.redirectToHboUrl);
    }

    function onDisneyRegistrationClick() {
        props.setRegistrationParams(DISNEY_REGISTRATION_PARAMS);
        props.setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_EXIST);
        props.setSelectedTvSubscriber(props.selectedSubscriber?.subscriberNo);
        props.context.navigateTo(Config.redirectToDisneyUrl);
    }


    let currentPageView = (
        <>
            <PackageHeader selectedPackage={props.selectedPackage} defaultImage={props.defaultImage} />
            <PackageExistDetails selectedPackage={props.selectedPackage} onClickBtnBack={handleOnClickBtnBack} onClickRemovePackageButton={handleOnClickRemovePackageButton} onClickHboChangeButton={handleOnClickHboChangeButton} onHboRegistrationClick={onHboRegistrationClick} onDisneyRegistrationClick={onDisneyRegistrationClick} />
        </>

    );

    return (
        <div>
            {currentPageHeadline}
            <div className='premium-packages-catalog-content'>
                <form noValidate id={formid} onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
            </div>
        </div>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }

    function handleOnClickBtnBack() {
        if (props.selectedPackage.duration == 0) {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'click_7',
                eventLabel: extraBoldTitle,
            });
        }
        else {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'click_8',
                eventLabel: extraBoldTitle,
            });
        }

        props.goToPage('packagesPage');

    }

    function handleOnClickRemovePackageButton() {
        props.reportAnalytics({
            eventCategory: 'premium_packages',
            eventAction: 'click_6',
            eventLabel: extraBoldTitle,
        });
        props.reportAnalytics({
            eventCategory: 'premium_packages',
            eventAction: 'visibility_6',
            eventLabel: 'element_7',
        });
        props.setPopUp({ isDisplay: true, type: 'alertBeforeRemovePackage', packageTitle: extraBoldTitle });
    }

    function handleOnClickHboChangeButton() {
        const packageId = props.selectedPackage.subList[0].Code;
        const url = new URL(window.location.href);
        url.searchParams.set('packageid', packageId);
        window.history.replaceState(null, '', url.href);
        const availablePackage = props.availablePackages?.find(x => x.name === packageId);
        if (availablePackage) {
            props.setSelectedPackage(availablePackage);
        }
        props.goToPage('packagesWorldPage');
    }

};

const mapStateToProps = (state) => {
    return {
        defaultImage: state.premiumPackagesCatalog.epiData?.defaultImage,
        selectedPackage: state.premiumPackagesCatalog.selectedPackage,
        selectedSubscriber: state.premiumPackagesCatalog.selectedSubscriber,
        availablePackages: state.premiumPackagesCatalog.availablePackages,
    };
};

const mapDispatchToProps = {
    goToPage,
    setIsSubmit,
    setSelectedPackage,
    premiumPackageActionAsync,
    setPopUp,
    reportDWH,
    reportAnalytics,
    setCurrentProcess,
    setSelectedTvSubscriber,
    setRegistrationParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageExistPage);
